import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import * as Redux from 'redux'
import {
    FormControlLabel,
    FormHelperText,
    Grid,
    RadioGroup,
} from '@mui/material'
import { ClientActionTypes } from '@ClientStores/client.action-types'
import BaseButton from '@Components/Form/BaseButton/BaseButton'
import { BaseRadio } from '@Components/Form/BaseRadio/BaseRadio'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import UploadImage from '@Components/Form/UploadImage/UploadImage'
import CustomModal from '@Components/Modal/CustomModal/CustomModal'
import InstructionModal from './InstructionModal'

interface ILostOfStolen {
    item: any
    open: boolean
    onClose: (action: string) => void
    onClickAction?: (action: string, payload?: any) => void
    // updateStatus?: (id: string, payload: any) => Promise<any>
    updateStatus?: (id: string, payload: any) => any
    getItemLostOrStolen?: (payload: any) => void
    radioValue?: string
    setRadioValue?: any
}

function LostOfStolen(props: ILostOfStolen) {
    // core section
    const {
        item,
        open,
        radioValue,
        setRadioValue,
        onClose,
        onClickAction,
        updateStatus,
        getItemLostOrStolen,
    } = props
    const [readOnly, setReadOnly] = useState(true)
    // const [radioValue, setRadioValue] = useState('')
    // states section

    // functions section
    const onChangeRadio = (value: string) => {
        setRadioValue(value)
    }

    const onSubmit = () => {
        if (radioValue) {
            const body = {
                id: item?.id,
                status: radioValue,
            }
            // if (getItemLostOrStolen) getItemLostOrStolen(body)
            if (onClickAction) onClickAction('INSTRUCTION', body)
            // updateStatus(item?.id, body)
        }
    }

    return (
        <>
            <CustomModal
                onClose={(action) => onClose && onClose(action)}
                open={open && open}
                modalTitle="Lost or Stolen"
            >
                <div className="modal-body p-0">
                    <Grid container spacing={3}>
                        <Grid item sm={6}>
                            <UploadImage
                                className="gray-bg"
                                imageUrl={item?.imageUrl}
                                style={{ height: 174 }}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            {/* <div className="d-flex align-items-center justify-content-center">
                                <div className="mr-2">
                                    <BaseRadio
                                        id="lost"
                                        inputProps={{ 'aria-label': `LOST` }}
                                        name="lostorStolen"
                                        value="LOST"
                                    />
                                    Lost
                                </div>
                                <div>
                                    <BaseRadio
                                        id="stolen"
                                        inputProps={{ 'aria-label': `STOLEN` }}
                                        name="lostorStolen"
                                        value="STOLEN"
                                    />
                                    Stolen
                                </div>
                            </div> */}
                            <div className="d-flex justify-content-center">
                                <RadioGroup
                                    className="d-flex flex-row align-items-center flex-nowrap"
                                    value={radioValue}
                                    onChange={(e) =>
                                        onChangeRadio(e?.target?.value)
                                    }
                                >
                                    <FormControlLabel
                                        control={<BaseRadio value="LOST" />}
                                        label={
                                            <span className="gray-text mr-2">
                                                Lost
                                            </span>
                                        }
                                        className="m-0"
                                    />
                                    <FormControlLabel
                                        control={<BaseRadio value="STOLEN" />}
                                        label={
                                            <span className="gray-text mr-2">
                                                Stolen
                                            </span>
                                        }
                                        className="m-0"
                                    />
                                </RadioGroup>
                            </div>
                            <RedditTextField
                                label="Make"
                                className="reddit-input mb-2 w-100"
                                variant="filled"
                                defaultValue={item?.makeName}
                                inputProps={{ readOnly }}
                            />
                            <RedditTextField
                                label="Model"
                                className="reddit-input mb-2 w-100"
                                variant="filled"
                                defaultValue={item?.modelName}
                                inputProps={{ readOnly }}
                            />
                            <RedditTextField
                                label="Caliber"
                                className="reddit-input mb-2 w-100"
                                variant="filled"
                                defaultValue={item?.caliber}
                                inputProps={{ readOnly }}
                            />
                            <RedditTextField
                                label="Serial #"
                                className="reddit-input mb-2 w-100"
                                variant="filled"
                                defaultValue={item?.serialCode}
                                inputProps={{ readOnly }}
                            />
                            <RedditTextField
                                label="Firearms Type"
                                className="reddit-input mb-2 w-100"
                                variant="filled"
                                defaultValue={item?.firearmTypeName}
                                inputProps={{ readOnly }}
                            />
                        </Grid>
                    </Grid>
                    <div className="text-right mt-2">
                        <BaseButton
                            className="outline-gray btn-lg-width"
                            onClick={onSubmit}
                            disabled={!radioValue}
                        >
                            Print Instructions
                        </BaseButton>
                    </div>
                </div>
            </CustomModal>
        </>
    )
}
const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    // return {
    //     updateStatus: (id: string, payload: any) => {
    //         dispatch(AdminMyVaultActions.updateStolenOrLost(id, payload) as any)
    //     },
    // }
    return {
        getItemLostOrStolen: (payload: any) =>
            dispatch({
                type: ClientActionTypes.GET_ITEM_STOLEN_OR_LOST,
                payload,
            }),
    }
}

export default connect(null, mapDispatchToProps)(LostOfStolen)
